
const TiposSaldoReais = {
   deposito: 1,
   saque: 2
}


export default TiposSaldoReais;